import {
  Amount,
  IDsData,
} from '@sky-distribution/adapter-core-pc-rest-interfaces';
import {
  Consent,
  Amount as DigitalAmount,
  DigitalGpSubmission,
  DigitalGpSubmissionBindResponse,
  DigitalGpSubmissionCalculateArgs,
  DigitalGpSubmissionCalculateResponse,
  DigitalGpSubmissionProposeResponse,
  DigitalGpSubmissionSaveResponse,
  Ids,
  TrackingCodes,
} from '@sky-distribution/digital-gp-submission';
import {
  bind,
  calculate,
  propose,
  save,
} from '../api/api';
import { getDigitalSubmissionWithMetaData } from '../util';

export const calculateDigital = async (
  digitalSubmission: DigitalGpSubmission,
  productId: string,
  tenant: string,
  trackingCodes: TrackingCodes = {},
): Promise<DigitalGpSubmissionCalculateResponse> => {
  const submission = getDigitalSubmissionWithMetaData(digitalSubmission, trackingCodes);

  return calculate(
    submission as DigitalGpSubmissionCalculateArgs, productId, tenant,
  );
};

export const createDigital = (
  arg: DigitalGpSubmission,
  productId: string,
  tenant: string,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
  trackingCodes: TrackingCodes = {},
): Promise<DigitalGpSubmissionSaveResponse> => {
  const submission = getDigitalSubmissionWithMetaData(arg, trackingCodes);

  return save(submission, productId, tenant, consentStatus, consentDictionary);
};

export const updateDigital = (
  arg: DigitalGpSubmission,
  ids: IDsData,
  productId: string,
  tenant: string,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
  trackingCodes: TrackingCodes,
): Promise<DigitalGpSubmissionSaveResponse> => {
  const submission = getDigitalSubmissionWithMetaData(arg, trackingCodes);

  return save(
    submission, productId, tenant, consentStatus, consentDictionary, ids as Ids,
  );
};

export const proposeDigital = (
  arg: DigitalGpSubmission,
  ids: IDsData,
  productId: string,
  tenant: string,
  totalPrice: Amount | undefined,
  returnUrl: string | undefined,
): Promise<DigitalGpSubmissionProposeResponse> => {
  const { emailAddress1, firstName, lastName } = arg.baseData.accountHolder.person;

  const absoluteReturnUrl = window.location.origin && returnUrl
    ? `${window.location.origin}${returnUrl}`
    : undefined;

  return propose(
    {
      amount: totalPrice?.amount as number,
      emailAddress: emailAddress1 as string,
      ids: ids as Ids,
      firstName: firstName as string,
      lastName: lastName as string,
      returnUrl: absoluteReturnUrl,
    },
    productId,
    tenant,
  );
};

export const bindDigital = async (
  arg: DigitalGpSubmission,
  ids: IDsData,
  productId: string,
  tenant: string,
  otpCode: string | undefined,
  totalPrice: Amount | undefined,
): Promise<DigitalGpSubmissionBindResponse> => bind(
  {
    phoneNumber: arg.baseData.accountHolder.person.homeNumber as string,
    otpCode: otpCode as string,
    amount: totalPrice as DigitalAmount,
    ids: ids as Ids,
  },
  productId,
  tenant,
);
